export const configs = {
    // api_domain: 'http://125.212.233.185:9093/',
    // base_api: 'http://125.212.233.185:9093{area}/api/',
    // base_partner_api: 'http://125.212.233.185:9093/partner/api/',
    //base_api: 'http://localhost:62692/api/',
    // domain: 'http://localhost:3000/',

    // api_domain: 'http://195.201.57.180:82/',
    // base_api: 'http://195.201.57.180:82{area}/api/',
    // base_partner_api: 'http://195.201.57.180:82/partner/api',


    api_domain: 'https://api.nailspaofamerica.com/',
    base_api: 'https://api.nailspaofamerica.com{area}/api/',
    base_partner_api: 'https://api.nailspaofamerica.com/partner/api',
    domain: 'https://nailspaofamerica.com/',
    posUploadDomain: "http://pos.nailspaofamerica.com/ClientWeb/FileUpload/",


    dateFormat: 'MMMM DD, YYYY',
    timeFormat: 'hh:mm a',
    googleMapKey: "AIzaSyCGvpr_xMAATGZq3ymDZH6wsT1wNoOpK_Q"
}
export const PAGE_SIZE = 10


// WEBPACK FOOTER //
// ./src/helpers/constants.js